// Import the Hero component for displaying the page banner
import Hero from "../../frontend/components/Hero";
// Import an image to use as the background for the Hero section
import CalculatorsImag1 from "../../assets/images/checking-data-laptop.jpg";
// Import the calculator component for Mortgage Repayment calculations
import MortgageRepaymentCalculator from "../../frontend/components/calculators/MortgageRepaymentCalculator";

// Main page component for the Mortgage Repayment calculator
const MortgageRepaymentCalculatorsPage = () => {
  return (
    <div>
      {/* Hero section with title and background image */}
      <Hero
        title="Mortgage Repayment"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      {/* Render the Mortgage Repayment Calculator */}
      <MortgageRepaymentCalculator />
      {/* Placeholder for additional content or layout, currently commented out */}
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

// Export the page component as default
export default MortgageRepaymentCalculatorsPage;
